import { Department } from "@/models/Department";

const headers = {
  contentType: "multipart/form-data",
};
const setSelectedItem = async ({ state, commit }, department:Department): Promise<void> => {
  commit("SET_SELECTED_DEPARTMENT", department);
};
const showFormModal = ({ commit }): void => {
  commit("SHOW_FORM_MODAL");
};

const hideFormModal = ({ commit }): void => {
  commit("HIDE_FORM_MODAL");
};

export default {
  setSelectedItem,
  showFormModal,
  hideFormModal
};
